import { toast } from "react-toastify";

const handleSuccess = (message) => {
  toast.success(message);
};

export default handleSuccess;
